/* jshint node:true */
'use strict';

var React                   = require('react');
var DateFormatMixin         = require('../../../mixins/DateFormatMixin');

var GameInformation = React.createClass({

    displayName: 'GameInformation',

    mixins: [DateFormatMixin],

    renderAttendance: function() {
        var iCapacity   = this.props.capacity || 0;
        var iAttendance = this.props.attendance || 0;

        iAttendance = isNaN(iAttendance) ? 0 : iAttendance;
        iCapacity = isNaN(iCapacity) ? 0 : iCapacity;

        if(iCapacity && iAttendance){

            var sPercent =  parseInt((iAttendance/iCapacity)*100);
            if(sPercent> 100){
                sPercent = 100;
            }
            sPercent += '%'
            return (
                <div className="attendance">
    				<div className="people">
    					<div className="people-all"></div>
    					<div className="attendance-bar" style={{width:sPercent}}></div>
    				</div>
    				<span className="percentage">{sPercent}</span>
    				<div className="capacity">Attendance: {this.formatNubmer(iAttendance)}</div>
    			</div>
            )
        }else if(iAttendance){
            return (
                <div className="capacity">Attendance: {this.formatNubmer(iAttendance)}</div>
            )
        }else{
            return null;
        }

    },

    renderCapacity: function() {
        var iCapacity   = this.props.capacity || 0;
        iCapacity       = isNaN(iCapacity) ? 0 : iCapacity;

        if(iCapacity){
            return (
                <div className="capacity">Capacity: {this.formatNubmer(iCapacity)}</div>
            )
        }else{
            return null;
        }
    },

    renderWeather: function(){

        var sAddress   = this.props.address || '';
        if(sAddress === ''){
            return null;
        }

        /* the requirment to return only 1 object means i need to return an array if i wrap this object it breaks the css */
        var aReturn = [];

        //aReturn.push(
        //	<div className="accuweather"></div>
        //);
        //<li className="icon-font-after icon-weather-rain-outline-after"></li>
        //<li className="temperature">22&deg;</li>

        aReturn.push(
			<ul key="location">
				<li className="icon-font-before icon-location-solid-before">{sAddress}</li>
			</ul>
        );

        return aReturn;
    },

    formatNubmer: function(x) {
        var parts = x.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return parts.join(".");
    },

    renderVenue: function(){

        var sImageUrl       = this.props.image || ''
        var sVenue          = this.props.venue || '--';

        if(sImageUrl != ''){
            return (
                <figure>
    				<img src={sImageUrl} />
    				<figcaption><div className="caption-wrapper">{sVenue}</div></figcaption>
    			</figure>
            );
        }else{
            return (
                <div className="game-details location-details">
                    <div className="capacity">Venue: {sVenue}</div>
                </div>
            )
        }
    },

    render: function () {

        var rWeather    = this.renderWeather();
        var rCapacity   = this.renderCapacity();
        var rAttendance = this.renderAttendance();
        var rVenueName  = this.renderVenue();
        var iDate       = this.props.datetime;
        var sCoverage   = this.props.coverage;
        var sVenue      = this.props.venue || '--';
        var sDate       = "";

        if(iDate){
            sDate = this.dateFormat(iDate,'dateTime1');
        }

        if(sCoverage){
            sCoverage = "Coverage: "+sCoverage;
        }
        // className="bordered"
        return (
            <article className="sub-module game-information">
            	<header>
            		<h1>Game Information</h1>
            	</header>
            	<div className="content">
            		<div className="game-field">
            			{rVenueName}
            			<div className="game-details">
            				<div className="game-date-time">{sDate}</div>
            				<div className="game-network">{sCoverage}</div>
            			</div>
            		</div>
            		<div className="location-details">
            			{rWeather}
            			{rCapacity}
            			{rAttendance}
            		</div>
            	</div>
            </article>
        );

    }
});

module.exports = GameInformation;



/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/rugby/game/GameInformation.jsx
 **/